import http from 'utils/http';
import { BillingStatsResponse, StripeCheckoutResponse, TransactionResponse } from './types';
import { getBillingStatsUrl, getCancelSubscriptionUrl, getCheckoutUrl, getTransactionsUrl } from './apiUrls';

export function stripeCheckout(): Promise<StripeCheckoutResponse> {
  return http.post(getCheckoutUrl());
}

export function cancelSubscription(workspaceId: string): Promise<{ manage_url: string }> {
  return http.get(getCancelSubscriptionUrl(workspaceId));
}

export function getTransactions(workspaceId: string): Promise<{ data: TransactionResponse[] }> {
  return http.get(getTransactionsUrl(workspaceId));
}

export function getBillingStats(): Promise<BillingStatsResponse> {
  return http.get(getBillingStatsUrl());
}
